import axios from 'axios'

export const request =
  (token = '') =>
  (url = '', method = 'get', data = null, customHeaders = {}) => {
    const headers = Object.assign(
      {},
      token ? { Authorization: `JWT ${token}` } : {},
      { 'X-Favor-User-Agent': 'Favor runner_apply web 1' },
      customHeaders
    )

    return axios({
      url,
      method,
      data,
      headers,
      timeout: 10000
    })
  }

export default request
